module.exports = __webpack_public_path__ + "static/media/CHE.34976948.svg";